"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTxRidValid = exports.TxRidSchema = void 0;
const errors_1 = require("../errors");
const bufferSchema_1 = require("./bufferSchema");
exports.TxRidSchema = bufferSchema_1.BufferSchema.refine(x => x.length === 32, "Rid must be 32 bytes long");
const isTxRidValid = (rid, options) => {
    const TxRidValidationContext = exports.TxRidSchema.safeParse(rid);
    const { throwOnError = false } = options || {};
    const hasError = "error" in TxRidValidationContext;
    if (!hasError) {
        return { success: true };
    }
    const validationError = new errors_1.InvalidTxRidException(rid);
    if (throwOnError) {
        throw validationError;
    }
    return {
        success: false,
        error: TxRidValidationContext.error,
        message: validationError.message,
    };
};
exports.isTxRidValid = isTxRidValid;
//# sourceMappingURL=txRid.js.map